/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmailHealthResponseDto,
  EmailRecipientDto,
  EmailResponseDto,
  ErrorResponse,
  TreatmentPlanEmailDto,
} from '../models/index';
import {
    EmailHealthResponseDtoFromJSON,
    EmailHealthResponseDtoToJSON,
    EmailRecipientDtoFromJSON,
    EmailRecipientDtoToJSON,
    EmailResponseDtoFromJSON,
    EmailResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    TreatmentPlanEmailDtoFromJSON,
    TreatmentPlanEmailDtoToJSON,
} from '../models/index';

export interface SendAdminInvitationEmailRequest {
    emailRecipientDto: EmailRecipientDto;
}

export interface SendAllEmailTemplatesRequest {
    emailRecipientDto: EmailRecipientDto;
}

export interface SendNotificationEmailRequest {
    emailRecipientDto: EmailRecipientDto;
}

export interface SendPasswordResetEmailRequest {
    emailRecipientDto: EmailRecipientDto;
}

export interface SendPasswordUpdatedEmailRequest {
    emailRecipientDto: EmailRecipientDto;
}

export interface SendSimpleEmailRequest {
    emailRecipientDto: EmailRecipientDto;
}

export interface SendTreatmentPlanGeneratedEmailRequest {
    treatmentPlanEmailDto: TreatmentPlanEmailDto;
}

export interface SendWelcomeEmailRequest {
    emailRecipientDto: EmailRecipientDto;
}

/**
 * 
 */
export class EmailApi extends runtime.BaseAPI {

    /**
     * Verify that the email service is connected and operational
     * Check email service health
     */
    async emailHealthCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailHealthResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailHealthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Verify that the email service is connected and operational
     * Check email service health
     */
    async emailHealthCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailHealthResponseDto> {
        const response = await this.emailHealthCheckRaw(initOverrides);
        return await response.value();
    }

    /**
     * Send a test admin invitation email using the template
     * Send admin invitation email
     */
    async sendAdminInvitationEmailRaw(requestParameters: SendAdminInvitationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendAdminInvitationEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/admin-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send a test admin invitation email using the template
     * Send admin invitation email
     */
    async sendAdminInvitationEmail(requestParameters: SendAdminInvitationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendAdminInvitationEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send all email templates (welcome, password-reset, notification)
     * Send all email templates
     */
    async sendAllEmailTemplatesRaw(requestParameters: SendAllEmailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendAllEmailTemplates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send all email templates (welcome, password-reset, notification)
     * Send all email templates
     */
    async sendAllEmailTemplates(requestParameters: SendAllEmailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendAllEmailTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a generic notification email using the template
     * Send a notification email
     */
    async sendNotificationEmailRaw(requestParameters: SendNotificationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendNotificationEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/notification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send a generic notification email using the template
     * Send a notification email
     */
    async sendNotificationEmail(requestParameters: SendNotificationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendNotificationEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a password reset email using the template
     * Send a password reset email
     */
    async sendPasswordResetEmailRaw(requestParameters: SendPasswordResetEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendPasswordResetEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/password-reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send a password reset email using the template
     * Send a password reset email
     */
    async sendPasswordResetEmail(requestParameters: SendPasswordResetEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendPasswordResetEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a confirmation email after password has been updated
     * Send a password updated email
     */
    async sendPasswordUpdatedEmailRaw(requestParameters: SendPasswordUpdatedEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendPasswordUpdatedEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/password-updated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send a confirmation email after password has been updated
     * Send a password updated email
     */
    async sendPasswordUpdatedEmail(requestParameters: SendPasswordUpdatedEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendPasswordUpdatedEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a simple HTML email
     * Send a simple email
     */
    async sendSimpleEmailRaw(requestParameters: SendSimpleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendSimpleEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/simple`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send a simple HTML email
     * Send a simple email
     */
    async sendSimpleEmail(requestParameters: SendSimpleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendSimpleEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send an email notification when a treatment plan has been generated
     * Send a treatment plan generated email
     */
    async sendTreatmentPlanGeneratedEmailRaw(requestParameters: SendTreatmentPlanGeneratedEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['treatmentPlanEmailDto'] == null) {
            throw new runtime.RequiredError(
                'treatmentPlanEmailDto',
                'Required parameter "treatmentPlanEmailDto" was null or undefined when calling sendTreatmentPlanGeneratedEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/treatment-plan-generated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TreatmentPlanEmailDtoToJSON(requestParameters['treatmentPlanEmailDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send an email notification when a treatment plan has been generated
     * Send a treatment plan generated email
     */
    async sendTreatmentPlanGeneratedEmail(requestParameters: SendTreatmentPlanGeneratedEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendTreatmentPlanGeneratedEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a welcome email using the template
     * Send a welcome email
     */
    async sendWelcomeEmailRaw(requestParameters: SendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailResponseDto>> {
        if (requestParameters['emailRecipientDto'] == null) {
            throw new runtime.RequiredError(
                'emailRecipientDto',
                'Required parameter "emailRecipientDto" was null or undefined when calling sendWelcomeEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/email/send/welcome`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailRecipientDtoToJSON(requestParameters['emailRecipientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send a welcome email using the template
     * Send a welcome email
     */
    async sendWelcomeEmail(requestParameters: SendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailResponseDto> {
        const response = await this.sendWelcomeEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
